<template>
  <!-- 底部 -->
  <div class="footer">
    <van-collapse v-model="companyText">
      <van-collapse-item name="1">
        <template #title>
          <div class="foot-title">集团</div>
        </template>
        <div class="n-title">公司介绍</div>
        <div class="n-title">业务场景</div>
        <div class="n-title">热点资讯</div>
      </van-collapse-item>
    </van-collapse>
    <van-collapse v-model="noticeText">
      <van-collapse-item name="1">
        <template #title>
          <div class="foot-title">政策公告</div>
        </template>
        <div class="n-title">政策公告</div>
      </van-collapse-item>
    </van-collapse>
    <van-collapse v-model="enduText">
      <van-collapse-item name="1">
        <template #title>
          <div class="foot-title">人才教育培训</div>
        </template>
        <div class="n-title">人才教育培训</div>
      </van-collapse-item>
    </van-collapse>
    <van-collapse v-model="nurseText">
      <van-collapse-item name="1">
        <template #title>
          <div class="foot-title">护理园地</div>
        </template>
        <div class="n-title">护理园地</div>
      </van-collapse-item>
    </van-collapse>
    <div class="foot-text top">联系我们</div>
    <div class="foot-text">公司电话：<span>857857967</span></div>
    <div class="foot-text">公司地址：深圳市龙岗区天安云谷11栋24</div>
    <div class="code-box van-hairline--bottom">
      <img :src="qrCode" alt="公众号二维码" />
      <img :src="wxCode" alt="小程序二维码" />
      <img :src="wxCode1" alt="小程序二维码" />
    </div>
    <div class="copy-right">
      © Copyright 2018 柏瑞康集团 | All rights reserved 京ICP备16000000号-1
    </div>
    <div class="bottom-box">
      <div class="left">企业招聘 <span>联系我们</span></div>
      网站地图
    </div>
  </div>
</template>
<script>
import qrCode from "@/assets/mobile/qrcode.png";
import wxCode from "@/assets/mobile/wxcode.png";
import wxCode1 from "@/assets/mobile/wxcode1.png";
export default {
  data() {
    return {
      qrCode,
      wxCode,
      wxCode1,
      companyNav: false,
      cList: [
        {
          name: "公司介绍",
          url: ""
        },
        {
          name: "业务场景",
          url: ""
        },
        {
          name: "热点资讯",
          url: ""
        }
      ],
      onHeight: "",
      companyText: [],
      noticeText: [],
      enduText: [],
      nurseText: []
    };
  },
  methods: {
    openTitle(index) {
      console.log(index);
      if (index == 1) {
        this.companyNav = !this.companyNav;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.footer {
  padding: 20px 30px 46px;
  background-color: #2a2a32;
  .foot-title {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 36px;
    font-weight: 500;
    color: #ffffff;
  }
  .n-title {
    padding-bottom: 30px;
    font-size: 28px;
    font-weight: 500;
    color: #ffffff;
    line-height: 42px;
  }
  .top {
    padding-top: 58px;
  }
  .foot-text {
    padding-bottom: 30px;
    font-size: 28px;
    color: #ffffff;
    span {
      color: #ffa168;
    }
  }
  .code-box {
    padding: 10px 0 48px;
    &::after {
      border-color: rgba($color: #ffffff, $alpha: 0.5);
    }
    img {
      width: 138px;
      height: 140px;
      margin-right: 50px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .copy-right {
    padding: 28px 0;
    font-size: 20px;
    font-weight: 500;
    color: rgba($color: #ffffff, $alpha: 0.6);
    line-height: 30px;
  }
  .bottom-box {
    display: flex;
    justify-content: space-between;
    font-size: 28px;
    font-weight: 500;
    color: #ffffff;
    line-height: 42px;
    span {
      margin-left: 30px;
    }
  }
}
/deep/ .van-cell {
  padding: 26px 0;
  background-color: #2a2a32;
}
/deep/ .van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-top: none;
  border-color: rgba($color: #ffffff, $alpha: 0.5);
}
/deep/ .van-collapse-item__content {
  padding: 35px 0 0;
  background-color: #2a2a32;
}
/deep/ .van-cell--clickable:active {
  background-color: #2a2a32;
}
/deep/ .van-collapse-item__title--expanded::after {
  right: 0;
  left: 0;
  border-color: rgba($color: #ffffff, $alpha: 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/footerBox.vue